import { render } from "./officialMaterial.vue?vue&type=template&id=7a74c978&scoped=true"
import script from "./officialMaterial.vue?vue&type=script&lang=js"
export * from "./officialMaterial.vue?vue&type=script&lang=js"

import "./officialMaterial.vue?vue&type=style&index=0&id=7a74c978&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a74c978"]])

export default __exports__